var tags = {};
export {
  tags as __exports
};
//# sourceMappingURL=tags.js.map
